const NavBar = () => {
    return (
        <div className="navbar">
            <span id="guess">GuessThe</span><span id="country">Country</span>
        </div>
    )
}

export default NavBar